<template>
  <!-- 评委信息管理 -->
  <div class="judgesInfo">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入用户名/姓名" style="width: 200px; margin-right:10px"
                  @keyup.enter.native="tableLoad" @clear="
            query.query = '';
            tableLoad();
          " clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button size="small" @click="tableLoad">查询</el-button>
        </Debounce>
      </el-col>
      <el-button type="primary" size="small" @click="operatInfo(1)" v-if="$roleFilter('judge:add')">添加</el-button>
      <FileOperatDropdown @reLoad="tableLoad" style="margin:0px 10px;"
                          :roles="[$roleFilter('judge:download'),$roleFilter('judge:import'),$roleFilter('judge:export')]"
                          :uploadUrl="'judge/importJudge'"
                          :downloadUrl="'judge/download'" :exportUrl="'/judge/export'" :exportData="query"
                          :butText="['下载模板','导入评委','导出评委']"/>
      <el-button type="danger" size="small" @click="operatInfo(0)" v-if="$roleFilter('judge:delete')">删除</el-button>
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
              :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中"
              @selection-change="handleSelectionChange" :height="$store.getters.getTableHeight">
      <el-table-column type="selection" align="center" width="50"></el-table-column>
      <el-table-column prop="userName" label="用户名" align="center"></el-table-column>
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column prop="idNumber" label="证件号码" align="center"></el-table-column>
      <el-table-column prop="sex_dictText" label="性别" align="center"></el-table-column>
      <el-table-column prop="mobile" label="联系电话" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="tableContentUpdateBut" size="small" @click="operatInfo(2, scope.row)"
                     v-if="$roleFilter('judge:update')">修改
          </el-button>
          <span style="margin:0px 10px;"
                v-if="$roleFilter('judge:update') && $roleFilter('judge:init:password')">|</span>
          <Debounce>
            <el-button type="text" size="small" @click="operatInfo(3, scope.row)"
                       v-if="$roleFilter('judge:init:password')">密码初始化
            </el-button>
          </Debounce>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"
                @pagination="tableLoad"/>
    <el-dialog custom-class="dailogComponents" :title="visibleType == 1 ? '添加' : '修改'" :visible.sync="visible"
               :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="400px">
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>用户名:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.userName" placeholder="请输入用户名"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>姓名:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.name" placeholder="请输入姓名"></el-input>
          </el-col>
        </el-row>
        <el-row v-if="visibleType === 1" type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>密码:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.passWord" placeholder="请输入密码"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>性别:</p>
          </el-col>
          <el-col :offset="1">
            <el-radio-group v-model="visibleObj.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p>证件号码:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.idNumber" placeholder="请输入证件号码"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>联系电话:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.mobile" placeholder="请输入手机号"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="primary" @click="submit">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileOperatDropdown from '@/views/admin/components/FileOperatDropdown'

export default {
  components: {
    FileOperatDropdown,
  },
  data() {
    return {
      tableList: [],
      tableSelectList: [],
      tableIsLoad: true,
      roleList: [],
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        mobile: "", //手机号
        name: "", //姓名
        passWord: "", //角色
        sex: 1, //性别
        userName: "", //用户名
      },
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
      },
    };
  },
  mounted() {
    this.tableLoad();
  },
  methods: {
    tableLoad() {
      this.$axios.post("/judge/list", this.query).then((res) => {
        console.log(res);
        let {
          list,
          total
        } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    handleSelectionChange(val) {
      this.tableSelectList = val;
    },
    operatInfo(type, row) {
      this.visibleType = type;
      this.visibleObj = {
        mobile: "", //手机号
        name: "", //姓名
        passWord: "", //角色
        sex: 1, //性别
        userName: "", //用户名
      };
      if (type === 0) {
        //删除
        if (this.tableSelectList.length === 0) {
          this.$message({
            type: "warning",
            message: "请选择数据进行删除!", duration: 1000
          });
          return;
        }
        let isRemove = true;//是否可以删除
        let submitIdList = this.tableSelectList.map((item) => {
          if (item.link != 0) {
            isRemove = false;
          }
          return item.userId;
        });
        let context = isRemove ? "是否删除所选内容?" : '该评委已打分，删除后评分信息无法恢复 ，是否继续删除？';
        //删除
        this.$dailog({
          title: "删除",
          context,
          callbackFun: () => {
            this.$axios
                .delete("/judge", {
                  data: submitIdList,
                })
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: "操作成功!", duration: 1000
                  });
                  this.tableLoad();
                });
          },
        });
      } else if (type === 1) {
        //添加
        this.visible = true;
      } else if (type === 3) {
        this.$dailog({
          title: "密码初始化",
          context: "确认修改密码为当前联系电话?",
          callbackFun: () => {
            this.initPassword(row);
          },
        });
      } else {
        //修改
        this.visible = true;
        this.visibleObj = JSON.parse(JSON.stringify(row));
      }
    },
    //密码初始化
    initPassword(row) {
      this.$axios({
        method: "post",
        url: "/judge/initial",
        data: [{
          mobile: row.mobile,
          name: row.name,
          passWord: row.passWord,
          sex: row.sex,
          userId: row.userId,
          userName: row.userName,
        },],
      }).then((res) => {
        this.$message({
          type: "success",
          message: "密码初始化成功!", duration: 1000
        });
      });
    },
    submit() {
      let {
        userName,
        name,
        mobile,
        userId,
        passWord
      } = this.visibleObj;
      if (userName === "" || name === "" || mobile === "" || passWord === "") {
        this.$message({
          type: "warning",
          message: "必填项不能为空!", duration: 1000
        });
        return;
      }
      let subType = this.visibleType === 1 ? "post" : "put";
      this.$axios({
        method: subType,
        url: "/judge",
        data: this.visibleObj,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "保存成功!", duration: 1000
        });
        this.visible = false;
        this.tableLoad();
      });
    },
  },
};
</script>
